import {ChevronRightIcon} from '@heroicons/react/outline';

import Button from '@/components/common/Button';
import {Table, Th, Thead, Tr} from '@/components/Table/Table';
import type {UserDetailsReturnProps} from '@/screens/User/Details/types';

import NoteTableBody from './NoteTableBody';

type NoteTableType = Pick<
  UserDetailsReturnProps,
  | 'hasMoreNotes'
  | 'loadMoreSecurityNotes'
  | 'securityNotes'
  | 'isFetchingMore'
  | 'dataCy'
>;

const NoteTable = ({
  securityNotes,
  hasMoreNotes,
  loadMoreSecurityNotes,
  isFetchingMore,
  dataCy,
}: NoteTableType) => {
  return (
    <div className="w-full mt-3">
      <div
        className={`${
          securityNotes?.length ? 'max-h-[400px] overflow-y-auto' : ''
        } overflow-x-hidden`}
      >
        <Table
          containerDataCy={dataCy ? `${dataCy}-notes-container` : undefined}
        >
          <Thead>
            <Tr enableHover={false}>
              <Th className="px-4 py-2 text-left">Date</Th>
              <Th className="px-4 py-2 text-left">Initiator</Th>
              <Th className="px-4 py-2 text-left">Note</Th>
              <Th className="px-4 py-2 text-left">Reason</Th>
              <Th className="px-4 py-2 text-left">Action</Th>
            </Tr>
          </Thead>

          <NoteTableBody dataCy={dataCy} securityNotes={securityNotes} />
        </Table>
      </div>

      <div className="flex justify-end mt-4">
        {hasMoreNotes && (
          <Button
            variant="outline"
            colorScheme="cyan"
            onClick={loadMoreSecurityNotes}
            disabled={isFetchingMore}
            rightIcon={
              !isFetchingMore && <ChevronRightIcon className="w-5 h-5" />
            }
            className="px-4 py-2 rounded"
            isLoading={isFetchingMore}
          >
            View More
          </Button>
        )}
      </div>
    </div>
  );
};

export default NoteTable;
